import FetchService from './fetch.service';
import localStorageService from './localStorage.service';

export const sendSlackTestMessage = async (reqData) => {
    const fetchService = new FetchService();

    const companyId = localStorageService.getCompanyId();

    const response = await fetchService("/configurations/test-slack-bot/", {
        method: 'POST',
        cache: 'no-cache',
        mode: 'cors',
        body: JSON.stringify({...reqData, 'company_id': companyId}),
        headers: {
            'Accept': 'application/json',
            "Content-Type": 'application/json',
        },
        credentials: 'include',
    });

    const resJson = await response.json();


    return resJson;
}